/**
 * @generated SignedSource<<b483733813ce26d106abbbf3023a3d15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type moduleSection_PotentialAnalysisModuleFragment$data = {
  readonly dimensions: ReadonlyArray<{
    readonly dimensionId: number;
    readonly " $fragmentSpreads": FragmentRefs<"dimensionSection_PotentialAnalysisDimensionFragment">;
  }>;
  readonly moduleId: number;
  readonly moduleText: string;
  readonly " $fragmentType": "moduleSection_PotentialAnalysisModuleFragment";
};
export type moduleSection_PotentialAnalysisModuleFragment$key = {
  readonly " $data"?: moduleSection_PotentialAnalysisModuleFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"moduleSection_PotentialAnalysisModuleFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "moduleSection_PotentialAnalysisModuleFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PotentialAnalysis_Dimension",
      "kind": "LinkedField",
      "name": "dimensions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dimensionId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "dimensionSection_PotentialAnalysisDimensionFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "moduleId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "moduleText",
      "storageKey": null
    }
  ],
  "type": "PotentialAnalysis_Module",
  "abstractKey": null
};

(node as any).hash = "9a917210675788c69d43cf46c43947a6";

export default node;
